import { render, staticRenderFns } from "./TheTextArea.vue?vue&type=template&id=1e4b8723"
import script from "./TheTextArea.vue?vue&type=script&lang=js"
export * from "./TheTextArea.vue?vue&type=script&lang=js"
import style0 from "./TheTextArea.vue?vue&type=style&index=0&id=1e4b8723&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports